module.exports = __webpack_public_path__ + "img/LeilaAlland.e330fb83.png";